import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from './assets/audio/bgm-wish.mp3'
import _imports_1 from './assets/audio/exit-dialog.mp3'


const _hoisted_1 = {
  key: 0,
  ref: "audioBgm",
  preload: "true",
  autoplay: "",
  loop: ""
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("source", { src: _imports_0 }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  id: "audioExitDialogDEPRECATED",
  ref: "audioExitDialog",
  preload: "true"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("source", { src: _imports_1 }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fate_purchase_dialog = _resolveComponent("fate-purchase-dialog")!
  const _component_item_obtain_overlay = _resolveComponent("item-obtain-overlay")!
  const _component_quest_screen = _resolveComponent("quest-screen")!
  const _component_wish_banners = _resolveComponent("wish-banners")!
  const _component_item_reveal_screen = _resolveComponent("item-reveal-screen")!
  const _component_item_all_reveal_screen = _resolveComponent("item-all-reveal-screen")!
  const _component_video_player = _resolveComponent("video-player")!
  const _component_shop_screen = _resolveComponent("shop-screen")!
  const _component_game_menu = _resolveComponent("game-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.screen !== 'game')
      ? (_openBlock(), _createElementBlock("audio", _hoisted_1, _hoisted_3, 512))
      : _createCommentVNode("", true),
    _createElementVNode("audio", _hoisted_4, _hoisted_6, 512),
    (
      _ctx.pullNumber > (_ctx.useStandardFates ? _ctx.inv.standardFates : _ctx.inv.fates) &&
      _ctx.checkPullDialog
    )
      ? (_openBlock(), _createBlock(_component_fate_purchase_dialog, {
          key: 1,
          "fates-to-purchase": _ctx.fatesToPurchase,
          "use-standard-fates": _ctx.useStandardFates,
          "primo-balance": _ctx.inv.primos,
          onCancelWish: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exitConfirmCancelDialog(_ctx.cancelWish))),
          onWish: _cache[1] || (_cache[1] = ($event: any) => (_ctx.exitConfirmCancelDialog(_ctx.goWish, $event)))
        }, null, 8, ["fates-to-purchase", "use-standard-fates", "primo-balance"]))
      : _createCommentVNode("", true),
    (_ctx.pullExtraRewards.length > 0 && _ctx.screen === 'wish-banner')
      ? (_openBlock(), _createBlock(_component_item_obtain_overlay, {
          key: 2,
          description: "Extra",
          "obtained-items": _ctx.pullExtraRewards,
          onExit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pullExtraRewards = []))
        }, null, 8, ["obtained-items"]))
      : _createCommentVNode("", true),
    (_ctx.overlay === 'quests')
      ? (_openBlock(), _createBlock(_component_quest_screen, {
          key: 3,
          inventory: _ctx.inv,
          onExit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.overlay = ''))
        }, null, 8, ["inventory"]))
      : _createCommentVNode("", true),
    (_ctx.screen === 'wish-banner')
      ? (_openBlock(), _createBlock(_component_wish_banners, {
          key: 4,
          inventory: _ctx.inv,
          banners: _ctx.banners,
          "current-banner-index": _ctx.currentBannerIndex,
          onWish: _ctx.wish,
          onGoQuests: _cache[4] || (_cache[4] = ($event: any) => (_ctx.overlay = 'quests')),
          onGoShop: _cache[5] || (_cache[5] = ($event: any) => (_ctx.screen = 'shop')),
          onChangeBanner: _ctx.changeBannerIndex
        }, null, 8, ["inventory", "banners", "current-banner-index", "onWish", "onChangeBanner"]))
      : _createCommentVNode("", true),
    (_ctx.screen === 'item-reveal')
      ? (_openBlock(), _createBlock(_component_item_reveal_screen, {
          key: 5,
          "last-roll": _ctx.lastRoll,
          inventory: _ctx.inv,
          onExit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.screen = 'wish-banner')),
          onRevealAll: _cache[7] || (_cache[7] = ($event: any) => (_ctx.screen = 'item-all-reveal'))
        }, null, 8, ["last-roll", "inventory"]))
      : _createCommentVNode("", true),
    (_ctx.screen === 'item-all-reveal')
      ? (_openBlock(), _createBlock(_component_item_all_reveal_screen, {
          key: 6,
          "last-roll": _ctx.lastRoll,
          inventory: _ctx.inv,
          "extra-rewards": _ctx.detailedPullExtraRewards,
          onExit: _cache[8] || (_cache[8] = ($event: any) => (_ctx.screen = 'wish-banner'))
        }, null, 8, ["last-roll", "inventory", "extra-rewards"]))
      : _createCommentVNode("", true),
    (_ctx.screen === 'video-player')
      ? (_openBlock(), _createBlock(_component_video_player, {
          key: 7,
          pulls: _ctx.pullNumber,
          stars: _ctx.pullRarity,
          "preload-drops": _ctx.lastRoll,
          onVideoEnded: _ctx.showResults,
          onVideoSkipped: _ctx.showResultsEnd
        }, null, 8, ["pulls", "stars", "preload-drops", "onVideoEnded", "onVideoSkipped"]))
      : _createCommentVNode("", true),
    _createVNode(_component_video_player, {
      pulls: 1,
      stars: 1,
      preloader: true
    }),
    (_ctx.screen === 'shop')
      ? (_openBlock(), _createBlock(_component_shop_screen, {
          key: 8,
          inventory: _ctx.inv,
          onExit: _cache[9] || (_cache[9] = ($event: any) => (_ctx.screen = 'wish-banner'))
        }, null, 8, ["inventory"]))
      : _createCommentVNode("", true),
    (_ctx.screen === 'game')
      ? (_openBlock(), _createBlock(_component_game_menu, { key: 9 }))
      : _createCommentVNode("", true)
  ], 64))
}